export default "__VITE_ASSET__BJBjgmiH__"